(function () {
    'use strict';

    angular.module("imApp").factory("productSettingService", ['$ihttp', function ($ihttp) {
        let service = {
            getEdit: function (parms) {
                return $ihttp.post({
                    method: 674,
                    parameters: parms || {}
                });
            },
            saveObj: function (edit) {
                return $ihttp.post({
                    method: 676,
                    parameters: edit
                });
            },
            delete: function (productsetting_keyno) {
                return $ihttp.post({
                    method: 3591,
                    parameters: {
                        productsetting_keyno: productsetting_keyno
                    }
                });
            }
        };

        return service;
    }]);
})();
